module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    class: {
      isTouchEnabled: _vm.isTouch
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.isDemo) ? _c('demo-message') : _vm._e(), _c('notifications'), _c('modal'), _c('alerter', {
    ref: "alerter"
  }), (_vm.loading) ? _c('loading') : _vm._e(), _c('router-view', {
    staticClass: "scrollable",
    class: {
      'is-demo': _vm.isDemo
    },
    attrs: {
      "id": "main-view"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24c4592c","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Main.vue
// module id = 64w4
// module chunks = 0 1